<label class="accept-box">
  <ng-content></ng-content>
  <input [(ngModel)]="value" id="checkbox" type="checkbox" [disabled]="disabled" />
  <span class="acceptmark"></span>
</label>
